module.exports = __webpack_public_path__ + "static/about-0d2b1ccdf3116e9b7775de8ca5ab5316.jpg";